<div id="snickers">
  <div class="snickers-banner" [ngClass]="{'rtl': (langChosen=='ar')?true:false}">
    <!--  <img src="assets/img/snickers/banner-l.jpg" class="img-responsive" alt="">-->
    <!--  <img src="assets/img/snickers/banner-xl.jpg" class="img-responsive" alt="">-->

    <ng-container *ngIf="(langChosen=='ar')?true:false; else english">
      <div class="language-button" (click)="languageChange('en')">
        <svg-icon name="globe"></svg-icon>
        <p>English</p>

      </div>
    </ng-container>
    <ng-template #english>
      <div class="language-button" (click)="languageChange('ar')">
        <p>العربية</p>
        <svg-icon name="globe"></svg-icon>
      </div>
    </ng-template>
    <div class="logo">
      <img src="assets/img/snickers/logo.png" class="img-responsive" alt="">
    </div>
    <div class="text">
      <img [src]="(langChosen=='en')?'assets/img/snickers/snickers-text.png':'assets/img/snickers/snickers-text-ar.png'"
           class="img-responsive" alt="">
      <p> {{language?.banner_text}}</p>
      <div class="button-skew red">
        <p>{{language?.sign_up}}</p>
      </div>
    </div>
    <div class="powered-section">
      <p>{{language?.powered_by}}</p>
      <img src="assets/img/GBarena-type.svg" alt="">
    </div>
  </div>

  <div class="prizes-container">
    <div class="first-section">
      <svg-icon name="trophy"></svg-icon>
      <div class="text">
        <h1><span class="red">Score Big</span>&nbsp;<span class="yellow">Ultimate E-Cup</span></h1>
        <h1>Tournament prizes for the first three players</h1>
        <div class="button-skew red" style="align-self: flex-end">
          <p>{{language?.sign_up}}</p>
        </div>
      </div>
    </div>
    <div class="second-section">
      <div class="place">
        10,000 USD
        <div class="shape second">
          <p> 2nd</p>
        </div>
      </div>
      <div class="place">
        20,000 USD
        <div class="shape first">
          <p>1st</p>
        </div>
      </div>
      <div class="place">
        5,000 USD
        <div class="shape">
          <p> 3rd</p>
        </div>
      </div>
    </div>
  </div>
  <perfect-scrollbar class="scroll-x-container" [ngClass]="{'rtl': (langChosen=='ar')?true:false}">
    <div class="menu">
      <div class="container">
      <div class="flex_block mid">
          <div class="item" routerLink="./home" routerLinkActive="active">
            <p>{{language?.Menu.General_Information}}</p>
          </div>
          <div class="item" routerLink="./tournament-rules" routerLinkActive="active">
            <p>{{language?.Menu.Tournament_Rules}}</p>
          </div>
          <div class="item" routerLink="./participants" routerLinkActive="active">
            <p>{{language?.Menu.Qualified_Participants}}</p>
          </div>
          <div class="item" routerLink="./brackets" routerLinkActive="active">
            <p>{{language?.Menu.Tournament_Bracket}}</p>
          </div>
        </div>
      </div>
    </div>
  </perfect-scrollbar>

  <router-outlet></router-outlet>

</div>
